import axios from "axios";
import {
  getCertificationExamsUrl,
  getCertificationExamUrl,
  submitCertificationExamUrl,
  getMyAttemptsUrl,
  getMyCertificatesUrl,
} from "../utils/urls";

export const getCertificationExams = async () => {
  const res = await axios.get(getCertificationExamsUrl, { params: { active: true } });
  return res?.data?.data;
};

export const getCertificationExam = async (id) => {
  const res = await axios.get(getCertificationExamUrl(id));
  return res?.data?.data;
};

export const submitCertificationExam = async (id, answers) => {
  const res = await axios.post(submitCertificationExamUrl(id), { answers });
  return res?.data?.data;
};

export const getMyAttempts = async () => {
  const res = await axios.get(getMyAttemptsUrl);
  return res?.data?.data;
};

export const getMyCertificates = async () => {
  const res = await axios.get(getMyCertificatesUrl);
  return res?.data?.data;
};
